import { Alert, Box, Snackbar, useTheme } from '@mui/material';
import { TableBodySkeleton } from '../../common/components';

// Componentes separados
import { TableTitleBox } from '../../common/components';

import CouponsFilters from './components/CouponsFilters';
import CouponsDataTable from './components/CouponsDataTable';
import CouponsPagination from './components/CouponsPagination';
import EditCouponDialog from './components/EditCouponDialog';
import EditAdvanceDialog from './components/EditAdvanceDialog';

// Hook personalizado
import { useCouponsTable } from './hooks/useCouponsTable';

/**
 * Componente principal de la tabla de cupones
 * Refactorizado para mejor mantenimiento y responsividad
 */
const CouponsTable = () => {
  const theme = useTheme();

  // Hook personalizado que maneja toda la lógica
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    filter,
    plans,
    groups,
    selectedData,
    coeficienteActual,
    open,
    openAdelantoDialog,
    snackbar,
    downloadingPdfId,
    isDownloadingPdf,
    handleDownload,
    handleFilter,
    handleOpenDialog,
    handleClose,
    handleCloseSnackbar,
    handleSave,
    handleDeleteCoupon,
    handleRegenerateCouponQrs,
    regeneratingId,
    handlePageChange,
    handleRowsPerPageChange,
    dispatch,
    setEditCouponField,
    calculateInterest,
  } = useCouponsTable();

  return (
    <>
      <Box>
        <TableTitleBox title="Habitat 99 | Cupones | Ver Cupones" />

        <CouponsFilters filter={filter} handleFilter={handleFilter} plans={plans} groups={groups} />

        <CouponsDataTable
          data={data}
          isLoading={isLoading}
          onEdit={handleOpenDialog}
          onDelete={handleDeleteCoupon}
          onDownload={handleDownload}
          downloadingPdfId={downloadingPdfId}
          isDownloadingPdf={isDownloadingPdf}
          onRegenerate={handleRegenerateCouponQrs}
          regeneratingId={regeneratingId}
          LoadingComponent={TableBodySkeleton}
        />

        <CouponsPagination
          totalPages={totalPages}
          totalCount={totalCount}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
          theme={theme}
        />
      </Box>

      <EditCouponDialog
        open={open}
        onClose={handleClose}
        selectedData={selectedData}
        calculateInterest={calculateInterest}
      />

      <EditAdvanceDialog
        open={openAdelantoDialog}
        onClose={handleClose}
        onSave={handleSave}
        selectedData={selectedData}
        coeficienteActual={coeficienteActual}
        dispatch={dispatch}
        setEditCouponField={setEditCouponField}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CouponsTable;
